export default __webpack_public_path__ + "static/media/image19.363ff2e5.jpg";